/**
 * Maps URL status parameter to internal status representation.
 * URL uses 'active' while internal uses 'watching'.
 */
export const urlStatusToInternal = (urlStatus: string | null): string | null => {
  if (urlStatus === 'active') return 'watching';
  return urlStatus; // 'accepted', 'archive', or null
};

/**
 * Maps internal status to URL status parameter.
 * Internal uses 'watching' while URL uses 'active'.
 */
export const internalStatusToUrl = (internalStatus: string | null): string | null => {
  if (internalStatus === 'watching') return 'active';
  return internalStatus; // 'accepted', 'archive', or null
};

/**
 * Returns the API statuses array for a given filter type.
 */
export const getStatusesForFilter = (filter: string | null): string[] | undefined => {
  switch (filter) {
    case 'watching':
      return ['active'];
    case 'accepted':
      return ['accepted'];
    case 'archive':
      return ['completed', 'hidden', 'expired'];
    default:
      return undefined;
  }
};
